import type {
  UmmsSortBy,
  UmmStatus,
  GasFacilityUnavailabilityType,
  Direction,
  UmmType,
  UnavailabilityType,
  GasFacilityUnitOfMeasurementType,
  MmSortBy,
  MmStatus,
  TypeOfMaintenance,
} from 'src/apis/iip-service/types';
import { Colors } from 'src/styles';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const gasFacilityUnavailabilityTypeLabels: Record<
  GasFacilityUnavailabilityType,
  string
> = {
  OFFSHORE_PIPELINE_UNAVAILABILITY: 'Offshore Pipeline Unavailability',
  TRANSMISSION_SYSTEM_UNAVAILABILITY: 'Transmission System Unavailability',
  STORAGE_UNAVAILABILITY: 'Storage Unavailability',
  STORAGE_FACILITY_UNAVAILABILITY: 'Storage Facility Unavailability',
  INJECTION_UNAVAILABILITY: 'Injection Unavailability',
  WITHDRAWAL_UNAVAILABILITY: 'Withdrawal unavailability',
  GAS_TREATMENT_PLANT_UNAVAILABILITY: 'Gas Treatment Plant unavailability',
  REGASIFICATION_PLANT_UNAVAILABILITY: 'Regasification Plant Unavailability',
  COMPRESSOR_STATION_UNAVAILABILITY: 'Compressor Station Unavailability',
  GAS_PRODUCTION_FIELD_UNAVAILABILITY: 'Gas Production Field Unavailability',
  IMPORT_CONTRACT_CURTAILMENT: 'Import Contract Curtailment',
  CONSUMPTION_UNAVAILABILITY: 'Consumption Unavailability',
  OTHER_UNAVAILABILITY: 'Other Unavailability',
};

export const gasFacilityUnavailabilityTypeOptions = labelsToOptions(
  gasFacilityUnavailabilityTypeLabels
);
export const gasFacilityUnavailabilityTypeValues = labelsToValues(
  gasFacilityUnavailabilityTypeLabels
);

export const ummTypeLabels: Record<UmmType, string> = {
  UNAVAILABILITY_OF_GAS_FACILITIES: 'Unavailability of Gas Facilities',
  OTHER_MARKET_INFORMATION: 'Other Market Information',
};

export const ummTypeOptions = labelsToOptions(ummTypeLabels);
export const ummTypeValues = labelsToValues(ummTypeLabels);

export const gasFacilityUnitOfMeasurementTypeLabels: Record<
  GasFacilityUnitOfMeasurementType,
  string
> = {
  KWH_PER_DAY: 'kWh/d',
  KWH_PER_HOUR: 'kWh/h',
  GWH: 'GWh',
  GWH_PER_DAY: 'GWh/d',
  TWH: 'TWh',
  MCM_PER_DAY: 'mcm/d', // only v1
  GWH_PER_HOUR: 'GWh/h', // only v2
};

const {
  MCM_PER_DAY,
  GWH_PER_HOUR,
  ...baseGasFacilityUnitOfMeasurementTypeLabels
} = gasFacilityUnitOfMeasurementTypeLabels;

export const gasFacilityUnitOfMeasurementTypeOptionsV1 = labelsToOptions({
  ...baseGasFacilityUnitOfMeasurementTypeLabels,
  MCM_PER_DAY,
});

export const gasFacilityUnitOfMeasurementTypeOptionsV2 = labelsToOptions({
  ...baseGasFacilityUnitOfMeasurementTypeLabels,
  GWH_PER_HOUR,
});

export const unitOfMeasurementValues = labelsToValues(
  gasFacilityUnitOfMeasurementTypeLabels
);

export const directionLabels: Record<Direction, string> = {
  ENTRY: 'Entry',
  EXIT: 'Exit',
};

export const directionOptions = labelsToOptions(directionLabels);
export const directionValues = labelsToValues(directionLabels);

export const unavailabilityTypeLabels: Record<UnavailabilityType, string> = {
  PLANNED: 'Planned',
  UNPLANNED: 'Unplanned',
};

export const unavailabilityTypeOptions = labelsToOptions(
  unavailabilityTypeLabels
);
export const unavailabilityTypeValues = labelsToValues(
  unavailabilityTypeLabels
);

export const mmSortByLabels: Record<MmSortBy, string> = {
  EVENT_PERIOD_START: 'Event Period Start',
  PUBLICATION_DATE_TIME: 'Publication Date',
};

export const mmSortByValues = labelsToValues(mmSortByLabels);
export const mmSortByOptions = labelsToOptions(mmSortByLabels);

export const mmStatusLabels: Record<MmStatus, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DISMISSED: 'Dismissed',
};

export const mmStatusValues = labelsToValues(mmStatusLabels);
export const mmStatusOptions = labelsToOptions(mmStatusLabels);

export const mmStatusColors: Record<MmStatus, string> = {
  ACTIVE: Colors.success,
  INACTIVE: Colors.inactive,
  DISMISSED: Colors.warning,
};

export const typeOfMaintenanceLabels: Record<TypeOfMaintenance, string> = {
  PLANNED: 'Planned',
  UNPLANNED: 'Unplanned',
};

export const typeOfMaintenanceOptions = labelsToOptions(
  typeOfMaintenanceLabels
);

export const typeOfMaintenanceValues = labelsToValues(typeOfMaintenanceLabels);

export const ummStatusColors: Record<UmmStatus, string> = {
  ACTIVE: Colors.success,
  INACTIVE: Colors.inactive,
  DISMISSED: Colors.warning,
};

export const ummStatusLabels: Record<UmmStatus, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DISMISSED: 'Dismissed',
};

export const ummStatusValues = labelsToValues(ummStatusLabels);
export const ummStatusOptions = labelsToOptions(ummStatusLabels);

export const ummSortByLabels: Record<UmmsSortBy, string> = {
  EVENT_START: 'Event Period Start',
  PUBLICATION_DATE_TIME: 'Publication Date',
};

export const ummSortByValues = labelsToValues(ummSortByLabels);
export const ummSortByOptions = labelsToOptions(ummSortByLabels);
